import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { VoiceRecorderComponent } from './voice-recorder/voice-recorder.component';
import { DetailsComponent } from './details/details.component';
import { UploadService } from './services/upload.service';
import { LearnMoreComponent } from './learn-more/learn-more.component';
import { AuthComponent } from './auth/auth.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AuthService } from './services/auth.service';

const routes: Routes = [
  { path: 'home', component: DetailsComponent },
  { path: 'learn_more', component: LearnMoreComponent },
  { path: 'auth', component: AuthComponent },
  { path: 'analytics', component: DashboardComponent },
  {
    path: 'dashboard',
    canActivate: [AuthService],
    component: DashboardComponent,
  },
  {
    path: 'record',
    canActivate: [UploadService],
    component: VoiceRecorderComponent,
  },
  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
